export const indexedMap = () => {
  const map = new Map();
  return {
    get: (firstId, secondId) => {
      var _map$get;
      return (_map$get = map.get(firstId)) === null || _map$get === void 0 ? void 0 : _map$get.get(secondId);
    },
    set: (firstId, secondId, value) => {
      const innerMap = map.get(firstId);
      if (innerMap) {
        innerMap.set(secondId, value);
      } else {
        map.set(firstId, new Map([[secondId, value]]));
      }
    },
    delete: (firstId, secondId) => {
      const innerMap = map.get(firstId);
      innerMap === null || innerMap === void 0 || innerMap.delete(secondId);
      if ((innerMap === null || innerMap === void 0 ? void 0 : innerMap.size) === 0) {
        map.delete(firstId);
      }
    }
  };
};